/**
 * Created by Dhanya Akhil on 1/30/2017.
 */
import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppComponent } from "../../../../app.component";
import { AccountType } from "../../../../shared/types/account.type";
import { Router } from "@angular/router";
import { ProfileService } from "../../../../shared/services/profile.service";
import { PrincipalService } from "../../../../shared/services/principal.service";
import { WindowRef } from "../../../../shared/services/window.service";
import { Account } from "../../../balance/types/account.type";

@Component({
  selector: "navbarMenu",
  templateUrl: "menu.html",
  styleUrls: ["./../navbar.component.scss"],
  host: {
    "(document:click)": "handleClick($event)",
  },
})
export class NavbarMenuComponent implements OnInit {
  @Input() isToggleMobileMenu:boolean = false
  @Output() newItemEvent = new EventEmitter<any>();
  public isNavbarCollapsed = true;
  public elementRef;
  private _window: Window;
  public highlightedDiv: number;
  public account: AccountType;
  public authenticatedMenus;
  public isEmployee: boolean;

  private ROLE_EMPLOYEE = "pA7qRrD3OcbtjAUmwKuJ5A==";

  constructor(
    public app: AppComponent,
    public myElement: ElementRef,
    public windowRef: WindowRef,
    public principal: PrincipalService,
    public router: Router,
    public profileService: ProfileService,
    private principalService: PrincipalService
  ) {
    this.elementRef = myElement;
    this._window = windowRef.nativeWindow;
    this.isEmployee = false;
  }

  ngOnInit() {
    this.highlightedDiv = 1;
    this.principalService.identity(true).then(
      (account: Account) => {
        if (account == null) {
          this.router.navigate(["login"]);
        } else {
          const userRole = account.authorities[0];
          if (userRole == this.ROLE_EMPLOYEE) {
            this.isEmployee = true;
          }
          this.autheMenu();
        }
      },
      (error) => {
        this.router.navigate(["login"]);
      }
    );
  }

  addNewItem(value: string) {
    this.newItemEvent.emit(value);
    console.log(value)
  }

  public toggleHighlight(newValue: number, flag) {
    if (this.highlightedDiv === newValue) {
      this.highlightedDiv = newValue;
    } else {
      if (flag != "home" && this.highlightedDiv === newValue) {
        this.highlightedDiv = 0;
      } else {
        this.highlightedDiv = newValue;
      }
    }
  }
  public autheMenu() {
    this.profileService.getAuthenticatedMenus().subscribe((menu) => {
      this.authenticatedMenus = menu;
    });
  }
  isActive(viewLocation) {
    var path = this.router.url;
    let currentMailUrl = path.split("/");
    var active = viewLocation === currentMailUrl[1];
    return active;
  }
  public toggleMenu1(event, mcount, metitle) {
    if (mcount == 3 && metitle == "Account") {
      mcount = 4;
    }
    if (mcount == 5 && metitle === "Calculator") {
      // in case of Employer
      mcount = 6;
    }
    if (mcount == 4 && metitle === "Calculator") {
      // in case of Employee
      mcount = 6;
    }
    if (mcount === 1) {
      this.app.menu2Opened = false;
      this.app.menu3Opened = false;
      this.app.menu4Opened = false;
      this.app.menu5Opened = false;
      this.app.menu6Opened = false;
      this.app.menu1Opened = !this.app.menu1Opened;
    }
    if (mcount === 2) {
      this.app.menu1Opened = false;
      this.app.menu3Opened = false;
      this.app.menu4Opened = false;
      this.app.menu5Opened = false;
      this.app.menu6Opened = false;
      this.app.menu2Opened = !this.app.menu2Opened;
    }
    if (mcount === 3) {
      this.app.menu1Opened = false;
      this.app.menu2Opened = false;
      this.app.menu4Opened = false;
      this.app.menu5Opened = false;
      this.app.menu6Opened = false;
      this.app.menu3Opened = !this.app.menu3Opened;
    }
    if (mcount === 4) {
      this.app.menu1Opened = false;
      this.app.menu2Opened = false;
      this.app.menu3Opened = false;
      this.app.menu5Opened = false;
      this.app.menu6Opened = false;
      this.app.menu4Opened = !this.app.menu4Opened;
    }
    if (mcount === 5) {
      this.app.menu1Opened = false;
      this.app.menu2Opened = false;
      this.app.menu3Opened = false;
      this.app.menu4Opened = false;
      this.app.menu6Opened = false;
      this.app.menu5Opened = !this.app.menu5Opened;
    }
    if (mcount === 6) {
      this.app.menu1Opened = false;
      this.app.menu2Opened = false;
      this.app.menu3Opened = false;
      this.app.menu4Opened = false;
      this.app.menu5Opened = false;
      this.app.menu6Opened = !this.app.menu6Opened;
    }
  }
  public handleLinkClick(mcount) {
    if (mcount === 1) {
      this.app.menu1Opened = !this.app.menu1Opened;
    }
    if (mcount === 2) {
      this.app.menu2Opened = !this.app.menu2Opened;
    }
    if (mcount === 3) {
      this.app.menu3Opened = !this.app.menu3Opened;
    }
    if (mcount === 4) {
      this.app.menu4Opened = !this.app.menu4Opened;
    }
    if (mcount === 5) {
      this.app.menu5Opened = !this.app.menu5Opened;
    }
    if (mcount === 6) {
      this.app.menu6Opened = !this.app.menu6Opened;
    }
  }
  public handleClick(event) {
    var clickedComponent = event.target;
    var inside = false;
    do {
      if (clickedComponent === this.elementRef.nativeElement) {
        inside = true;
      }
      clickedComponent = clickedComponent.parentNode;
    } while (clickedComponent);
    if (inside) {
    } else {
      this.app.menu1Opened = false;
      this.app.menu2Opened = false;
      this.app.menu3Opened = false;
      this.app.menu4Opened = false;
      this.app.menu5Opened = false;
      this.app.menu6Opened = false;
    }
  }

  public toggleNavbar() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }

  public collapseNavbar() {
    this.app.menu1Opened = false;
    this.app.menu2Opened = false;
    this.app.menu3Opened = false;
    this.app.menu4Opened = false;
    this.app.menu5Opened = false;
    this.app.menu6Opened = false;

    this.isNavbarCollapsed = true;
  }

}
